import * as e from "react";
import { c as ie, w as oe, r as ue, m as le, a as K } from "./room-BBI9Ul2f.mjs";
import { C as G, S as de, a as me, M as B, b as fe, T as R, c as he, d as pe, D as J, e as ge, f as H, L as Q, G as Ee, P as z, F as ve, g as Se, h as ke, R as be, i as Ce, j as we, k as ye, B as Ie } from "./components-DZxz2YwG.mjs";
import { w as Me, x as Ne, y as x, z as Pe, A as X, t as Y, B as Te, C as Le } from "./hooks-JwdUfgCD.mjs";
import { j as Z, am as Ae, an as De, l as P, a as Re, ao as Ve, ap as Oe, a1 as q, aq as $e, ar as Ue } from "./contexts-B7YgC7ji.mjs";
import { Mutex as _e, createLocalTracks as Fe, Track as I, facingModeFromLocalTrack as Be, createLocalVideoTrack as qe, VideoPresets as xe, createLocalAudioTrack as We, RoomEvent as je } from "livekit-client";
function ee({
  messageFormatter: i,
  messageDecoder: l,
  messageEncoder: o,
  channelTopic: a,
  ...v
}) {
  const p = e.useRef(null), f = e.useRef(null), u = e.useMemo(() => ({ messageDecoder: l, messageEncoder: o, channelTopic: a }), [l, o, a]), { send: d, chatMessages: g, isSending: t } = Me(u), m = Z(), c = e.useRef(0);
  async function S(s) {
    s.preventDefault(), p.current && p.current.value.trim() !== "" && d && (await d(p.current.value), p.current.value = "", p.current.focus());
  }
  return e.useEffect(() => {
    var s;
    f && ((s = f.current) == null || s.scrollTo({ top: f.current.scrollHeight }));
  }, [f, g]), e.useEffect(() => {
    var r, E, n, C, w;
    if (!m || g.length === 0)
      return;
    if ((r = m.widget.state) != null && r.showChat && g.length > 0 && c.current !== ((E = g[g.length - 1]) == null ? void 0 : E.timestamp)) {
      c.current = (n = g[g.length - 1]) == null ? void 0 : n.timestamp;
      return;
    }
    const s = g.filter(
      (A) => !c.current || A.timestamp > c.current
    ).length, { widget: h } = m;
    s > 0 && ((C = h.state) == null ? void 0 : C.unreadMessages) !== s && ((w = h.dispatch) == null || w.call(h, { msg: "unread_msg", count: s }));
  }, [g, m == null ? void 0 : m.widget]), /* @__PURE__ */ e.createElement("div", { ...v, className: "lk-chat" }, /* @__PURE__ */ e.createElement("div", { className: "lk-chat-header" }, "Messages", m && /* @__PURE__ */ e.createElement(G, { className: "lk-close-button" }, /* @__PURE__ */ e.createElement(de, null))), /* @__PURE__ */ e.createElement("ul", { className: "lk-list lk-chat-messages", ref: f }, v.children ? g.map(
    (s, h) => ie(v.children, {
      entry: s,
      key: s.id ?? h,
      messageFormatter: i
    })
  ) : g.map((s, h, r) => {
    const E = h >= 1 && r[h - 1].from === s.from, n = h >= 1 && s.timestamp - r[h - 1].timestamp < 6e4;
    return /* @__PURE__ */ e.createElement(
      me,
      {
        key: s.id ?? h,
        hideName: E,
        hideTimestamp: E === !1 ? !1 : n,
        entry: s,
        messageFormatter: i
      }
    );
  })), /* @__PURE__ */ e.createElement("form", { className: "lk-chat-form", onSubmit: S }, /* @__PURE__ */ e.createElement(
    "input",
    {
      className: "lk-form-control lk-chat-form-input",
      disabled: t,
      ref: p,
      type: "text",
      placeholder: "Enter a message...",
      onInput: (s) => s.stopPropagation(),
      onKeyDown: (s) => s.stopPropagation(),
      onKeyUp: (s) => s.stopPropagation()
    }
  ), /* @__PURE__ */ e.createElement("button", { type: "submit", className: "lk-button lk-chat-form-button", disabled: t }, "Send")));
}
function O({
  kind: i,
  initialSelection: l,
  onActiveDeviceChange: o,
  tracks: a,
  requestPermissions: v = !1,
  ...p
}) {
  const [f, u] = e.useState(!1), [d, g] = e.useState([]), [t, m] = e.useState(!0), [c, S] = e.useState(v), s = (n, C) => {
    P.debug("handle device change"), u(!1), o == null || o(n, C);
  }, h = e.useRef(null), r = e.useRef(null);
  e.useLayoutEffect(() => {
    f && S(!0);
  }, [f]), e.useLayoutEffect(() => {
    h.current && r.current && (d || t) && Ae(h.current, r.current).then(({ x: n, y: C }) => {
      r.current && Object.assign(r.current.style, { left: `${n}px`, top: `${C}px` });
    }), m(!1);
  }, [h, r, d, t]);
  const E = e.useCallback(
    (n) => {
      r.current && n.target !== h.current && f && De(r.current, n) && u(!1);
    },
    [f, r, h]
  );
  return e.useEffect(() => (document.addEventListener("click", E), window.addEventListener("resize", () => m(!0)), () => {
    document.removeEventListener("click", E), window.removeEventListener("resize", () => m(!0));
  }), [E, m]), /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "button",
    {
      className: "lk-button lk-button-menu",
      "aria-pressed": f,
      ...p,
      onClick: () => u(!f),
      ref: h
    },
    p.children
  ), !p.disabled && /* @__PURE__ */ e.createElement(
    "div",
    {
      className: "lk-device-menu",
      ref: r,
      style: { visibility: f ? "visible" : "hidden" }
    },
    i ? /* @__PURE__ */ e.createElement(
      B,
      {
        initialSelection: l,
        onActiveDeviceChange: (n) => s(i, n),
        onDeviceListChange: g,
        kind: i,
        track: a == null ? void 0 : a[i],
        requestPermissions: c
      }
    ) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: "lk-device-menu-heading" }, "Audio inputs"), /* @__PURE__ */ e.createElement(
      B,
      {
        kind: "audioinput",
        onActiveDeviceChange: (n) => s("audioinput", n),
        onDeviceListChange: g,
        track: a == null ? void 0 : a.audioinput,
        requestPermissions: c
      }
    ), /* @__PURE__ */ e.createElement("div", { className: "lk-device-menu-heading" }, "Video inputs"), /* @__PURE__ */ e.createElement(
      B,
      {
        kind: "videoinput",
        onActiveDeviceChange: (n) => s("videoinput", n),
        onDeviceListChange: g,
        track: a == null ? void 0 : a.videoinput,
        requestPermissions: c
      }
    ))
  ));
}
function W() {
  e.useEffect(() => {
    oe();
  }, []);
}
function ze(i, l) {
  const [o, a] = e.useState(), v = e.useMemo(() => new _e(), []);
  return e.useEffect(() => {
    let p = !1, f = [];
    return v.lock().then(async (u) => {
      try {
        (i.audio || i.video) && (f = await Fe(i), p ? f.forEach((d) => d.stop()) : a(f));
      } catch (d) {
        l && d instanceof Error ? l(d) : P.error(d);
      } finally {
        u();
      }
    }), () => {
      p = !0, f.forEach((u) => {
        u.stop();
      });
    };
  }, [JSON.stringify(i, ue), l, v]), o;
}
function Ze(i, l, o) {
  const [a, v] = e.useState(null), [p, f] = e.useState(!1), u = Ne({ kind: o }), [d, g] = e.useState(
    void 0
  ), [t, m] = e.useState(), [c, S] = e.useState(l);
  e.useEffect(() => {
    S(l);
  }, [l]);
  const s = async (E, n) => {
    try {
      const C = n === "videoinput" ? await qe({
        deviceId: E,
        resolution: xe.h720.resolution
      }) : await We({ deviceId: E }), w = await C.getDeviceId(!1);
      w && E !== w && (r.current = w, S(w)), m(C);
    } catch (C) {
      C instanceof Error && v(C);
    }
  }, h = async (E, n) => {
    await E.setDeviceId(n), r.current = n;
  }, r = e.useRef(c);
  return e.useEffect(() => {
    i && !t && !a && !p && (P.debug("creating track", o), f(!0), s(c, o).finally(() => {
      f(!1);
    }));
  }, [i, t, a, p]), e.useEffect(() => {
    t && (i ? d != null && d.deviceId && r.current !== (d == null ? void 0 : d.deviceId) ? (P.debug(`switching ${o} device from`, r.current, d.deviceId), h(t, d.deviceId)) : (P.debug(`unmuting local ${o} track`), t.unmute()) : (P.debug(`muting ${o} track`), t.mute().then(() => P.debug(t.mediaStreamTrack))));
  }, [t, d, i, o]), e.useEffect(() => () => {
    t && (P.debug(`stopping local ${o} track`), t.stop(), t.mute());
  }, []), e.useEffect(() => {
    g(u == null ? void 0 : u.find((E) => E.deviceId === c));
  }, [c, u]), {
    selectedDevice: d,
    localTrack: t,
    deviceError: a
  };
}
function et({
  defaults: i = {},
  onValidate: l,
  onSubmit: o,
  onError: a,
  debug: v,
  joinLabel: p = "Join Room",
  micLabel: f = "Microphone",
  camLabel: u = "Camera",
  userLabel: d = "Username",
  persistUserChoices: g = !0,
  videoProcessor: t,
  ...m
}) {
  const {
    userChoices: c,
    saveAudioInputDeviceId: S,
    saveAudioInputEnabled: s,
    saveVideoInputDeviceId: h,
    saveVideoInputEnabled: r,
    saveUsername: E
  } = x({
    defaults: i,
    preventSave: !g,
    preventLoad: !g
  }), [n, C] = e.useState(c), [w, A] = e.useState(n.audioEnabled), [y, L] = e.useState(n.videoEnabled), [T, $] = e.useState(n.audioDeviceId), [k, N] = e.useState(n.videoDeviceId), [V, ae] = e.useState(n.username);
  e.useEffect(() => {
    s(w);
  }, [w, s]), e.useEffect(() => {
    r(y);
  }, [y, r]), e.useEffect(() => {
    S(T);
  }, [T, S]), e.useEffect(() => {
    h(k);
  }, [k, h]), e.useEffect(() => {
    E(V);
  }, [V, E]);
  const D = ze(
    {
      audio: w ? { deviceId: c.audioDeviceId } : !1,
      video: y ? { deviceId: c.videoDeviceId, processor: t } : !1
    },
    a
  ), U = e.useRef(null), M = e.useMemo(
    () => D == null ? void 0 : D.filter((b) => b.kind === I.Kind.Video)[0],
    [D]
  ), ne = e.useMemo(() => {
    if (M) {
      const { facingMode: b } = Be(M);
      return b;
    } else
      return "undefined";
  }, [M]), j = e.useMemo(
    () => D == null ? void 0 : D.filter((b) => b.kind === I.Kind.Audio)[0],
    [D]
  );
  e.useEffect(() => (U.current && M && (M.unmute(), M.attach(U.current)), () => {
    M == null || M.detach();
  }), [M]);
  const [se, ce] = e.useState(), _ = e.useCallback(
    (b) => typeof l == "function" ? l(b) : b.username !== "",
    [l]
  );
  e.useEffect(() => {
    const b = {
      username: V,
      videoEnabled: y,
      videoDeviceId: k,
      audioEnabled: w,
      audioDeviceId: T
    };
    C(b), ce(_(b));
  }, [V, y, _, w, T, k]);
  function re(b) {
    b.preventDefault(), _(n) ? typeof o == "function" && o(n) : P.warn("Validation failed with: ", n);
  }
  return W(), /* @__PURE__ */ e.createElement("div", { className: "lk-prejoin", ...m }, /* @__PURE__ */ e.createElement("div", { className: "lk-video-container" }, M && /* @__PURE__ */ e.createElement("video", { ref: U, width: "1280", height: "720", "data-lk-facing-mode": ne }), (!M || !y) && /* @__PURE__ */ e.createElement("div", { className: "lk-camera-off-note" }, /* @__PURE__ */ e.createElement(fe, null))), /* @__PURE__ */ e.createElement("div", { className: "lk-button-group-container" }, /* @__PURE__ */ e.createElement("div", { className: "lk-button-group audio" }, /* @__PURE__ */ e.createElement(
    R,
    {
      initialState: w,
      source: I.Source.Microphone,
      onChange: (b) => A(b)
    },
    f
  ), /* @__PURE__ */ e.createElement("div", { className: "lk-button-group-menu" }, /* @__PURE__ */ e.createElement(
    O,
    {
      initialSelection: T,
      kind: "audioinput",
      disabled: !j,
      tracks: { audioinput: j },
      onActiveDeviceChange: (b, F) => $(F)
    }
  ))), /* @__PURE__ */ e.createElement("div", { className: "lk-button-group video" }, /* @__PURE__ */ e.createElement(
    R,
    {
      initialState: y,
      source: I.Source.Camera,
      onChange: (b) => L(b)
    },
    u
  ), /* @__PURE__ */ e.createElement("div", { className: "lk-button-group-menu" }, /* @__PURE__ */ e.createElement(
    O,
    {
      initialSelection: k,
      kind: "videoinput",
      disabled: !M,
      tracks: { videoinput: M },
      onActiveDeviceChange: (b, F) => N(F)
    }
  )))), /* @__PURE__ */ e.createElement("form", { className: "lk-username-container" }, /* @__PURE__ */ e.createElement(
    "input",
    {
      className: "lk-form-control",
      id: "username",
      name: "username",
      type: "text",
      defaultValue: V,
      placeholder: d,
      onChange: (b) => ae(b.target.value),
      autoComplete: "off"
    }
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      className: "lk-button lk-join-button",
      type: "submit",
      onClick: re,
      disabled: !se
    },
    p
  )), v && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("strong", null, "User Choices:"), /* @__PURE__ */ e.createElement("ul", { className: "lk-list", style: { overflow: "hidden", maxWidth: "15rem" } }, /* @__PURE__ */ e.createElement("li", null, "Username: ", `${n.username}`), /* @__PURE__ */ e.createElement("li", null, "Video Enabled: ", `${n.videoEnabled}`), /* @__PURE__ */ e.createElement("li", null, "Audio Enabled: ", `${n.audioEnabled}`), /* @__PURE__ */ e.createElement("li", null, "Video Device: ", `${n.videoDeviceId}`), /* @__PURE__ */ e.createElement("li", null, "Audio Device: ", `${n.audioDeviceId}`))));
}
function Ke({ props: i }) {
  const { dispatch: l, state: o } = Re().widget, a = "lk-button lk-settings-toggle";
  return { mergedProps: e.useMemo(() => le(i, {
    className: a,
    onClick: () => {
      l && l({ msg: "toggle_settings" });
    },
    "aria-pressed": o != null && o.showSettings ? "true" : "false"
  }), [i, a, l, o]) };
}
const Ge = /* @__PURE__ */ e.forwardRef(
  function(l, o) {
    const { mergedProps: a } = Ke({ props: l });
    return /* @__PURE__ */ e.createElement("button", { ref: o, ...a }, l.children);
  }
);
function te({
  variation: i,
  controls: l,
  saveUserChoices: o = !0,
  onDeviceError: a,
  ...v
}) {
  var $;
  const [p, f] = e.useState(!1), u = Z();
  e.useEffect(() => {
    var k, N;
    ((k = u == null ? void 0 : u.widget.state) == null ? void 0 : k.showChat) !== void 0 && f((N = u == null ? void 0 : u.widget.state) == null ? void 0 : N.showChat);
  }, [($ = u == null ? void 0 : u.widget.state) == null ? void 0 : $.showChat]);
  const g = Pe(`(max-width: ${p ? 1e3 : 760}px)`) ? "minimal" : "verbose";
  i ?? (i = g);
  const t = { leave: !0, ...l }, m = X();
  m ? (t.camera ?? (t.camera = m.canPublish), t.microphone ?? (t.microphone = m.canPublish), t.screenShare ?? (t.screenShare = m.canPublish), t.chat ?? (t.chat = m.canPublishData && (l == null ? void 0 : l.chat))) : (t.camera = !1, t.chat = !1, t.microphone = !1, t.screenShare = !1);
  const c = e.useMemo(
    () => i === "minimal" || i === "verbose",
    [i]
  ), S = e.useMemo(
    () => i === "textOnly" || i === "verbose",
    [i]
  ), s = Ve(), [h, r] = e.useState(!1), E = e.useCallback(
    (k) => {
      r(k);
    },
    [r]
  ), n = K({ className: "lk-control-bar" }, v), {
    saveAudioInputEnabled: C,
    saveVideoInputEnabled: w,
    saveAudioInputDeviceId: A,
    saveVideoInputDeviceId: y
  } = x({ preventSave: !o }), L = e.useCallback(
    (k, N) => N ? C(k) : null,
    [C]
  ), T = e.useCallback(
    (k, N) => N ? w(k) : null,
    [w]
  );
  return /* @__PURE__ */ e.createElement("div", { ...n }, t.microphone && /* @__PURE__ */ e.createElement("div", { className: "lk-button-group" }, /* @__PURE__ */ e.createElement(
    R,
    {
      source: I.Source.Microphone,
      showIcon: c,
      onChange: L,
      onDeviceError: (k) => a == null ? void 0 : a({ source: I.Source.Microphone, error: k })
    },
    S && "Microphone"
  ), /* @__PURE__ */ e.createElement("div", { className: "lk-button-group-menu" }, /* @__PURE__ */ e.createElement(
    O,
    {
      kind: "audioinput",
      onActiveDeviceChange: (k, N) => A(N ?? "default")
    }
  ))), t.camera && /* @__PURE__ */ e.createElement("div", { className: "lk-button-group" }, /* @__PURE__ */ e.createElement(
    R,
    {
      source: I.Source.Camera,
      showIcon: c,
      onChange: T,
      onDeviceError: (k) => a == null ? void 0 : a({ source: I.Source.Camera, error: k })
    },
    S && "Camera"
  ), /* @__PURE__ */ e.createElement("div", { className: "lk-button-group-menu" }, /* @__PURE__ */ e.createElement(
    O,
    {
      kind: "videoinput",
      onActiveDeviceChange: (k, N) => y(N ?? "default")
    }
  ))), t.screenShare && s && /* @__PURE__ */ e.createElement(
    R,
    {
      source: I.Source.ScreenShare,
      captureOptions: { audio: !0, selfBrowserSurface: "include" },
      showIcon: c,
      onChange: E,
      onDeviceError: (k) => a == null ? void 0 : a({ source: I.Source.ScreenShare, error: k })
    },
    S && (h ? "Stop screen share" : "Share screen")
  ), t.chat && /* @__PURE__ */ e.createElement(G, null, c && /* @__PURE__ */ e.createElement(he, null), S && "Chat"), t.settings && /* @__PURE__ */ e.createElement(Ge, null, c && /* @__PURE__ */ e.createElement(pe, null), S && "Settings"), t.leave && /* @__PURE__ */ e.createElement(J, null, c && /* @__PURE__ */ e.createElement(ge, null), S && "Leave"), /* @__PURE__ */ e.createElement(H, null));
}
function tt({
  chatMessageFormatter: i,
  chatMessageDecoder: l,
  chatMessageEncoder: o,
  SettingsComponent: a,
  ...v
}) {
  var s, h;
  const [p, f] = e.useState({
    showChat: !1,
    unreadMessages: 0,
    showSettings: !1
  }), u = e.useRef(null), d = Y(
    [
      { source: I.Source.Camera, withPlaceholder: !0 },
      { source: I.Source.ScreenShare, withPlaceholder: !1 }
    ],
    { updateOnlyOn: [je.ActiveSpeakersChanged], onlySubscribed: !1 }
  ), g = (r) => {
    P.debug("updating widget state", r), f(r);
  }, t = Oe(), m = d.filter(q).filter((r) => r.publication.source === I.Source.ScreenShare), c = (s = Te(t)) == null ? void 0 : s[0], S = d.filter((r) => !$e(r, c));
  return e.useEffect(() => {
    var r, E, n, C, w, A;
    if (m.some((y) => y.publication.isSubscribed) && u.current === null ? (P.debug("Auto set screen share focus:", { newScreenShareTrack: m[0] }), (E = (r = t.pin).dispatch) == null || E.call(r, { msg: "set_pin", trackReference: m[0] }), u.current = m[0]) : u.current && !m.some(
      (y) => {
        var L, T;
        return y.publication.trackSid === ((T = (L = u.current) == null ? void 0 : L.publication) == null ? void 0 : T.trackSid);
      }
    ) && (P.debug("Auto clearing screen share focus."), (C = (n = t.pin).dispatch) == null || C.call(n, { msg: "clear_pin" }), u.current = null), c && !q(c)) {
      const y = d.find(
        (L) => L.participant.identity === c.participant.identity && L.source === c.source
      );
      y !== c && q(y) && ((A = (w = t.pin).dispatch) == null || A.call(w, { msg: "set_pin", trackReference: y }));
    }
  }, [
    m.map((r) => `${r.publication.trackSid}_${r.publication.isSubscribed}`).join(),
    (h = c == null ? void 0 : c.publication) == null ? void 0 : h.trackSid,
    d
  ]), W(), /* @__PURE__ */ e.createElement("div", { className: "lk-video-conference", ...v }, Ue() && /* @__PURE__ */ e.createElement(
    Q,
    {
      value: t,
      onWidgetChange: g
    },
    /* @__PURE__ */ e.createElement("div", { className: "lk-video-conference-inner" }, c ? /* @__PURE__ */ e.createElement("div", { className: "lk-focus-layout-wrapper" }, /* @__PURE__ */ e.createElement(ve, null, /* @__PURE__ */ e.createElement(Se, { tracks: S }, /* @__PURE__ */ e.createElement(z, null)), c && /* @__PURE__ */ e.createElement(ke, { trackRef: c }))) : /* @__PURE__ */ e.createElement("div", { className: "lk-grid-layout-wrapper" }, /* @__PURE__ */ e.createElement(Ee, { tracks: d }, /* @__PURE__ */ e.createElement(z, null))), /* @__PURE__ */ e.createElement(te, { controls: { chat: !0, settings: !!a } })),
    /* @__PURE__ */ e.createElement(
      ee,
      {
        style: { display: p.showChat ? "grid" : "none" },
        messageFormatter: i,
        messageEncoder: o,
        messageDecoder: l
      }
    ),
    a && /* @__PURE__ */ e.createElement(
      "div",
      {
        className: "lk-settings-menu-modal",
        style: { display: p.showSettings ? "block" : "none" }
      },
      /* @__PURE__ */ e.createElement(a, null)
    )
  ), /* @__PURE__ */ e.createElement(be, null), /* @__PURE__ */ e.createElement(Ce, null));
}
function at({ ...i }) {
  const [l, o] = e.useState({
    showChat: !1,
    unreadMessages: 0
  }), a = Y([I.Source.Microphone]);
  return W(), /* @__PURE__ */ e.createElement(Q, { onWidgetChange: o }, /* @__PURE__ */ e.createElement("div", { className: "lk-audio-conference", ...i }, /* @__PURE__ */ e.createElement("div", { className: "lk-audio-conference-stage" }, /* @__PURE__ */ e.createElement(we, { tracks: a }, /* @__PURE__ */ e.createElement(ye, null))), /* @__PURE__ */ e.createElement(
    te,
    {
      controls: { microphone: !0, screenShare: !1, camera: !1, chat: !0 }
    }
  ), l.showChat && /* @__PURE__ */ e.createElement(ee, null)));
}
function nt({
  controls: i,
  saveUserChoices: l = !0,
  onDeviceError: o,
  ...a
}) {
  const v = { leave: !0, microphone: !0, ...i }, p = X(), { microphoneTrack: f, localParticipant: u } = Le(), d = e.useMemo(() => ({
    participant: u,
    source: I.Source.Microphone,
    publication: f
  }), [u, f]);
  p ? v.microphone ?? (v.microphone = p.canPublish) : v.microphone = !1;
  const g = K({ className: "lk-agent-control-bar" }, a), { saveAudioInputEnabled: t, saveAudioInputDeviceId: m } = x({
    preventSave: !l
  }), c = e.useCallback(
    (S, s) => {
      s && t(S);
    },
    [t]
  );
  return /* @__PURE__ */ e.createElement("div", { ...g }, v.microphone && /* @__PURE__ */ e.createElement("div", { className: "lk-button-group" }, /* @__PURE__ */ e.createElement(
    R,
    {
      source: I.Source.Microphone,
      showIcon: !0,
      onChange: c,
      onDeviceError: (S) => o == null ? void 0 : o({ source: I.Source.Microphone, error: S })
    },
    /* @__PURE__ */ e.createElement(Ie, { trackRef: d, barCount: 7, options: { minHeight: 5 } })
  ), /* @__PURE__ */ e.createElement("div", { className: "lk-button-group-menu" }, /* @__PURE__ */ e.createElement(
    O,
    {
      kind: "audioinput",
      onActiveDeviceChange: (S, s) => m(s ?? "default")
    }
  ))), v.leave && /* @__PURE__ */ e.createElement(J, null, "Disconnect"), /* @__PURE__ */ e.createElement(H, null));
}
export {
  at as AudioConference,
  ee as Chat,
  te as ControlBar,
  O as MediaDeviceMenu,
  et as PreJoin,
  tt as VideoConference,
  nt as VoiceAssistantControlBar,
  Ze as usePreviewDevice,
  ze as usePreviewTracks
};
//# sourceMappingURL=prefabs.mjs.map
